import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  ListItem: {
    paddingBottom: 15,
    width: "100%",
    height: "5em",
    "&:hover": {
      backgroundColor: "#f6f6f6",
    },
  },
  Button: {
    minWidth: "10em !important",
    fontSize: 12,
    padding: "3px !important",
    [theme.breakpoints.up("sm")]: {
      minWidth: "12em !important",
      padding: "10px !important",
    },
  },

  Card: {
    padding: 30,
    borderRadius: 20,
    minHeight: "80vh",
    background: "#fcfcfc",
    backgroundColor: '#eee',
    backgroundSize: "cover",
    [theme.breakpoints.up("sm")]: {
      padding: 30,
      borderRadius: 20,
      backgroundColor: '#eee',
      backgroundSize: "cover",
      minHeight: "30em",
      background: "#fcfcfc",
      margin: 20,
    },
  },
}));

export default useStyles;